module.exports = __webpack_public_path__ + "static/media/bronze.4d577847.png";